import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const beSendVoucherEmail = actionBe('beSendVoucherEmail', ({ AT, ATAG, voucherId, email }) =>
  endpoint(H.post, `payments/voucher/:salonId/send/insalon/:voucherId/`, {
    AT,
    name: ATAG,
    params: { voucherId },
    data: { send_to_email: email },
  }),
);

// noinspection JSUnusedGlobalSymbols
export default beSendVoucherEmail;
